import styled from "styled-components";

const InfoStyles = styled.div`
  padding: 0px 50px 0px 50px;
  max-width: 760px;
  margin: 0 auto;

  .team-bios {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: left;
    max-width: 660px;
    margin-top: 60px;
  }

  .bio-and-photo {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 60px;

    &:last-child {
      margin-bottom: 0px;
    }
  }

  .head-shot {
    height: 150px;
    width: 150px;
    border-radius: 100px;
    margin-right: 24px;

    img {
      border-radius: 100px;
    }
  }

  .team-member-desc {
    max-width: 486px;
    padding-top: 2px;
  }

  .name {
    font-family: var(--body-font-bold);
  }

  .role {
    margin-bottom: 12px;
  }

  .info {
    &__header-1 {
      font-family: var(--header-font) !important;
      font-weight: normal !important;
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 30px;
      text-transform: uppercase;
    }

    &__body-text {
      margin-bottom: 20px;
    }

    &__team-pic {
      content: "";
      background-image: url("https://i.imgur.com/ju8vHB5.jpg");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      height: 500px;
      width: 100%;
      margin: 0px auto;
      margin-top: 40px;
    }

    &__img {
      height: 450px;
      width: 100%;
      margin: 0px auto;
      margin-top: 40px;

      &-caption {
        width: 100%;
        font-size: 14px;
        line-height: 18px;
        color: var(--medium-gray);
      }
    }

    &__disclaimer {
      font-size: 14px !important;
      line-height: 22px !important;
      margin-top: 20px !important;
    }
  }

  @media only screen and (max-width: 785px) {
    .bio-and-photo {
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 40px;
    }

    .head-shot {
      margin-right: 0;
      margin-bottom: 8px;
    }

    .role {
      margin-bottom: 16px;
    }
  }

  @media only screen and (max-width: 650px) {
    padding: 0px 20px 0px 20px;
    width: 100%;

    .info {
      &__team-pic {
        height: 400px;
        background-position: 33% center;
        width: 100%;
      }

      &__img {
        height: 400px;
      }
    }
  }

  @media only screen and (max-width: 400px) {
    .info {
      &__team-pic {
        height: 350px;
        width: 100%;
      }
    }
  }
`;

export default InfoStyles;
